import {
  DELETE_COMPUTATION_SUMMARY,
  GET_COMPUTATION_SUMMARY,
  POST_COMPUTATION_SUMMARY,
  PUT_COMPUTATION_SUMMARY,
} from "../constants/actionTypes";

const defaultState = {};
let index = "";

export default (state = defaultState, action) => {
  try {
    switch (action.type) {
      case GET_COMPUTATION_SUMMARY:
        return { ...action.payload };
      case POST_COMPUTATION_SUMMARY:
        return { ...state, ...action.payload };
      case PUT_COMPUTATION_SUMMARY:
        return { ...state, ...action.payload };
      case DELETE_COMPUTATION_SUMMARY:
        return [...state.filter((data) => data?.id != action?.payload)];
      default:
        return state;
    }
  } catch (error) {
    throw new Error(error);
  }
};
